module.exports = __webpack_public_path__ + "assets/img/bannoudesign.70869455.svg";